export default __webpack_public_path__ + "static/media/step1_act.2c03ed73.svg";